const variables = require('!!extract-sass-variables-loader!bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss');

Object.seal(variables);

/**
 * @description
 * Static utility class designed to provide access to sass variables and bootstrap variables in particular.
 * It reads _variables-bootstrap.scss by default. May be overridden only once.
 */
class SassVariables {

    /**
     * @method
     * @description
     * Sets variables that may override original values. No new variable can be added though.
     * Variables may be overridden only once and are meant to be overridden by bespoke projects.
     *
     * @param {object} overrides Object comprising values that should override original values.
     */
    static setOverride(overrides) {
        Object.assign(variables, overrides);
        Object.freeze(variables);
    }

    /**
     * @method
     * @description
     * Provide access to any bootstrap variable. Camel case notation is used (screenXs for example).
     *
     * @param {string} name Name of variable, which value we want to obtain.
     */
    static getVariable(name) {
        return variables[name];
    }

}

export default SassVariables;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_services/utility/sass_variables.service.js